export enum SignalHookScopeType {
  ALL_REQUESTS = "all_requests",
  PROMPT_LABEL = "prompt_label",
  SPECIFIC_PROMPT = "specific_prompt",
}

export interface SignalHookFormState {
  id: string;
  bindingId: number | null;
  scopeType: SignalHookScopeType;
  sampleRate: number;
  labelNames: string[];
  promptId?: number;
  promptName?: string;
  promptFolderId?: number | null;
  versionNumber?: number | null;
  versionLabel?: string | null;
  variantType?: "version" | "label" | null;
}

export interface SignalFormState {
  name: string;
  prompt: string;
  enabled: boolean;
  hooks: SignalHookFormState[];
}

export enum SignalTestResultState {
  IDLE = "idle",
  LOADING = "loading",
  TRUE = "true",
  FALSE = "false",
  ERROR = "error",
}

export interface SignalTestRowState {
  requestLogId: number;
  result: SignalTestResultState;
  errorMessage?: string;
  details?: {
    label: string;
    reasoning?: string | null;
    citation?: string | null;
  } | null;
}
